<template>
  <layout-simple>
    <v-container fluid>
      <v-row align="center">
        <v-expansion-panels :multiple="true" :flat="false" :hover="true">
          <v-expansion-panel v-for="(item, i) in length" :key="i">
            <v-expansion-panel-header>{{ item }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import LayoutSimple from "@/layouts/LayoutSimple.vue";

@Component({
  components: { LayoutSimple }
})
export default class About extends Vue {
  length = ["Teilkasko", "Vollkasko", "Haftpflicht"];
  window = 0;
}
</script>
